/**
 * Warehouse tracking events.
 *
 * Naming: `warehouse.<action>` -- all snake_case.
 */

import { capture } from "./capture";

export const WarehouseTracking = {
  /** Auto Tune toggle switched on or off. */
  autoTuneToggled: (warehouseName: string, enabled: boolean) => {
    capture("warehouse.auto_tune_toggled", { warehouse_name: warehouseName, enabled });
  },

  /** Auto Tune configuration saved. */
  autoTuneConfigured: (
    warehouseName: string,
    resizingMode: string,
    resizingEnabled: boolean
  ) => {
    capture("warehouse.auto_tune_configured", {
      warehouse_name: warehouseName,
      resizing_mode: resizingMode,
      resizing_enabled: resizingEnabled,
    });
  },

  /** New schedule created. */
  scheduleCreated: (warehouseName: string, scheduleType: string) => {
    capture("warehouse.schedule_created", {
      warehouse_name: warehouseName,
      schedule_type: scheduleType,
    });
  },

  /** Existing schedule edited. */
  scheduleEdited: (warehouseName: string, scheduleId: string) => {
    capture("warehouse.schedule_edited", {
      warehouse_name: warehouseName,
      schedule_id: scheduleId,
    });
  },

  /** Schedule deleted (rejected). */
  scheduleDeleted: (warehouseName: string, scheduleId: string) => {
    capture("warehouse.schedule_deleted", {
      warehouse_name: warehouseName,
      schedule_id: scheduleId,
    });
  },

  /** Bulk approve ("apply schedule") confirmed. */
  schedulesApproved: (warehouseName: string, scheduleCount: number) => {
    capture("warehouse.schedules_approved", {
      warehouse_name: warehouseName,
      schedule_count: scheduleCount,
    });
  },

  /** Opportunity clicked / selected on details page. */
  opportunitySelected: (warehouseName: string, opportunityId: string) => {
    capture("warehouse.opportunity_selected", {
      warehouse_name: warehouseName,
      opportunity_id: opportunityId,
    });
  },
};
